/**
 * 认证相关 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';
import type { RequestOptions } from '@/utils';

// API Endpoints
const Api = {
    Login: '/Login',
    Logout: '/Logout',
    GetAuth: '/GetAuth',
    ChangePassword: '/ChangePassword',
};

/**
 * 登录（POST /Login）
 */
export async function login(params: API.LoginParams): Promise<API.LoginResult> {
    const response = await http.post<API.LoginResult>(Api.Login, params);
    return response?.Data || {};
}

/**
 * 登出（POST /Logout）。后端为无状态 JWT，退出时清理本地 token。
 */
export async function outLogin(): Promise<Record<string, any>> {
    await http.post(Api.Logout);
    return {};
}

/**
 * 获取当前用户（GET /GetAuth）
 */
export async function currentUser(options?: RequestOptions): Promise<{
    data: API.CurrentUser;
}> {
    const response = await http.get<API.CurrentUser>(Api.GetAuth, options);
    return { data: response.Data };
}

/**
 * 修改密码（POST /ChangePassword）
 */
export async function changePassword(params: {
    OldPassword: string;
    NewPassword: string;
}): Promise<void> {
    await http.post(Api.ChangePassword, params);
}
